<template>
  <section class="container">
    <h1 class="mb-1e is-size-3">Nie odwiedzać:</h1>

    <div v-if="Object.keys(grouped).length">
      <div
        v-for="(group, key) in grouped"
        :key="`group-${key}`">

        <NotVisitGroup :group="group" :territoryKey="key" />
      </div>
    </div>

    <article class="message is-info" v-else>
      <div class="message-header">
        <p>Nie dodano jeszcze żadnych adresów.</p>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import NotVisitGroup from '@/components/NotVisitGroup.vue';

export default {
  components: {
    NotVisitGroup,
  },
  computed: {
    ...mapGetters({
      grouped: 'GROUPED_NVS',
    }),
  },
  methods: {
    ...mapMutations({
      remove: 'REMOVE_NV',
    }),
  },
};
</script>
